<template>
  <div class="home">
    <div class="box_content">
      <div class="left">
        <div class="ren-status">
          <span>支付宝小程序认证状态</span>
          <span class="empower-status" v-if="noEmpower">已认证</span>
          <el-button v-else class="ren-btn" type="success" @click="gotoEmpower" round>立即认证</el-button>
        </div>
      </div>
      <!-- <div class="right">
        <img src="/public/img/all/logo.png" alt="">
        <div class="status_text">小程序 <div>{{empower_status}}</div></div>
        <div class="empower_button">
          <el-button v-if="noEmpower" type="text" @click="gotoEmpower">前往授权</el-button>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { AliMiniConfig, GetAliMiniConfigInfo, GetAliMiniSetInfo } from "@/api/configuration";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "status"])
  },
  data(){
    return{
      empower_status: "未认证",
      noEmpower: false,
      set_obj: {}
    }
  },
  mounted(){
    this.getData();
    this.getInfo();
  },
  methods:{
    async getData(){
      try {
        var data = { token: this.token, app_id: this.app_id };
        const res = await GetAliMiniConfigInfo(data);
        if (res.code == 200) {
          this.noEmpower = true;
          this.empower_status = "已认证"
        } else {
          this.noEmpower = false;
          throw(res.msg);
        }
      } catch (error) {
        console.log(error);
        this.$message(error)
      }
    },
    async getInfo() {
      try {
        var data = { token: this.token, app_id: this.app_id };
        const res = await GetAliMiniSetInfo(data);
        if (res.code == 200) {
          this.set_obj = res.data;
        } else {
          throw(res.msg);
        }
      } catch (error) {
        console.log(error)
      }
    },
    async gotoEmpower(){
      try {
        var data = { token: this.token, app_id: this.app_id };
        const res = await AliMiniConfig(data);
        window.location.href = res.data.url;
      } catch (error) {
        console.log(error); 
      }
    }
  }
}
</script>
<style lang="css" scoped>

</style>
<style lang="scss" scoped>
.home{
  padding: 20px;
  .box_content{
    display: flex;
    height: 600px;
    .left{
      border-radius: 10px;
      background: #fff;
      flex:3;
      .ren-status {
        width: 60%;
        height: 80px;
        display: flex;
        align-items: center;
        font-size: 18px;
        padding-left: 20px;
      }
      .empower-status {
        margin-left: 20px;
        color: #e84a5f;
      }
      .ren-btn {
        margin-left: 20px;
        font-size: 16px;
      }
      p{
        margin-top: 15px;
        padding-left: 18px;
        font-size: 16px;
        span{
          color: #999;
          font-size: 13px;
        }
      }
      .value_box{
        display: flex;
        padding: 20px 0;
        margin-bottom: 15px;
        div{
          text-align: center;
        }
        .value_left{
          flex:1;
          border-right:1px solid #eee;
        }
        .value_right{
          flex:1
        }
        .value_line{
          font-size: 25px;
        }
        .name_line{
          margin-top: 13px;
          color: #999;
          font-size: 12px;
        }
      }
    }
    .right{
      margin-left: 15px;
      border-radius: 10px;
      padding-top: 50px;
      padding-left: 95px;
      background: #fff;
      flex: 1;
      position: relative;
      img{
        margin-bottom: 20px;
      }
      .status_text{
        color: #999;
        div{
          color: #5cb87a;
          border: 1px solid #5cb87a;
          margin-left: 10px;
          display: inline-block;
          padding: 2px;
          border-radius: 5px;
        }
      }
      .empower_button{
        position: absolute;
        right:10px;
        top: 12px;
      }
    }
  }
}
</style>